// Generated by BUCKLESCRIPT VERSION 2.0.0, PLEASE EDIT WITH CARE
'use strict';

var List                    = require("bs-platform/lib/js/list.js");
var Tile                    = require("./Tile");
var $$Array                 = require("bs-platform/lib/js/array.js");
var Block                   = require("bs-platform/lib/js/block.js");
var Curry                   = require("bs-platform/lib/js/curry.js");
var React                   = require("react");
var Images                  = require("./Images");
var Random                  = require("bs-platform/lib/js/random.js");
var Caml_obj                = require("bs-platform/lib/js/caml_obj.js");
var Caml_array              = require("bs-platform/lib/js/caml_array.js");
var Caml_int32              = require("bs-platform/lib/js/caml_int32.js");
var Pervasives              = require("bs-platform/lib/js/pervasives.js");
var ReasonReact             = require("reason-react/lib/js/src/ReasonReact.js");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");

((require('./App.css')));

var $$document = (document);

var nbOfTiles = 9;

Random.self_init(/* () */0);

function getSwipeDirection(startX, startY, endX, endY) {
  var offsetX = endX - startX | 0;
  var offsetY = endY - startY | 0;
  var isHorizontalSwipe = +(Pervasives.abs(offsetX) > Pervasives.abs(offsetY));
  if (isHorizontalSwipe !== 0) {
    if (offsetX > 25) {
      return /* Right */3;
    } else if (offsetX < -25) {
      return /* Left */2;
    } else {
      return /* None */4;
    }
  } else if (offsetY > 25) {
    return /* Down */1;
  } else if (offsetY < -25) {
    return /* Up */0;
  } else {
    return /* None */4;
  }
}

function $neg$neg(i, j) {
  var _n = j;
  var _acc = /* [] */0;
  while(true) {
    var acc = _acc;
    var n = _n;
    if (n < i) {
      return acc;
    } else {
      _acc = /* :: */[
        n,
        acc
      ];
      _n = n - 1 | 0;
      continue ;
      
    }
  };
}

function getRandomDirection() {
  var rand = Random.$$int(4);
  if (rand > 3 || rand < 0) {
    return /* None */4;
  } else {
    switch (rand) {
      case 0 : 
          return /* Up */0;
      case 1 : 
          return /* Right */3;
      case 2 : 
          return /* Down */1;
      case 3 : 
          return /* Left */2;
      
    }
  }
}

function canMove(emptyTilePosition, direction) {
  switch (direction) {
    case 0 : 
        return +((emptyTilePosition / 3 | 0) < 2);
    case 1 : 
        return +((emptyTilePosition / 3 | 0) >= 1);
    case 2 : 
        return +(emptyTilePosition % 3 < 2);
    case 3 : 
        return +(emptyTilePosition % 3 > 0);
    case 4 : 
        return /* false */0;
    
  }
}

function getTileToMove(emptyTilePosition, direction) {
  switch (direction) {
    case 0 : 
        return emptyTilePosition + 3 | 0;
    case 1 : 
        return emptyTilePosition - 3 | 0;
    case 2 : 
        return emptyTilePosition + 1 | 0;
    case 3 : 
        return emptyTilePosition - 1 | 0;
    case 4 : 
        throw Caml_builtin_exceptions.not_found;
    
  }
}

function swap(tiles, a, b) {
  return List.map((function (tile) {
                if (Caml_obj.caml_equal(tile, a)) {
                  return b;
                } else if (Caml_obj.caml_equal(tile, b)) {
                  return a;
                } else {
                  return tile;
                }
              }), tiles);
}

function hasWon(tiles) {
  var _i = 0;
  var _tiles = tiles;
  while(true) {
    var tiles$1 = _tiles;
    var i = _i;
    if (tiles$1) {
      var match = +(tiles$1[0] === i);
      if (match !== 0) {
        _tiles = tiles$1[1];
        _i = i + 1 | 0;
        continue ;
        
      } else {
        return /* false */0;
      }
    } else {
      return /* true */1;
    }
  };
}

function initTiles() {
  var tiles = $neg$neg(0, 8);
  var _count = 80;
  var _tiles = tiles;
  while(true) {
    var tiles$1 = _tiles;
    var count = _count;
    if (count !== 0) {
      var direction = getRandomDirection(/* () */0);
      var emptyTilePosition = List.nth(tiles$1, nbOfTiles - 1 | 0);
      var toMove = getTileToMove(emptyTilePosition, direction);
      var match = canMove(emptyTilePosition, direction);
      var newTiles = match !== 0 ? swap(tiles$1, emptyTilePosition, toMove) : tiles$1;
      _tiles = newTiles;
      _count = count - 1 | 0;
      continue ;
      
    } else {
      return tiles$1;
    }
  };
}

function keyToDirection(key) {
  switch (key) {
    case "ArrowDown" : 
        return /* Down */1;
    case "ArrowLeft" : 
        return /* Left */2;
    case "ArrowRight" : 
        return /* Right */3;
    case "ArrowUp" : 
        return /* Up */0;
    default:
      return /* None */4;
  }
}

var component = ReasonReact.reducerComponent("App");

function make() {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      $$document.addEventListener("keydown", Curry._1(self[/* reduce */1], (function ($$event) {
                  return /* KeyDown */Block.__(0, [$$event.key]);
                })));
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var match = hasWon(self[/* state */2][/* tiles */2]);
      var match$1 = hasWon(self[/* state */2][/* tiles */2]);
      var match$2 = self[/* state */2][/* isTutorialVisible */3];
      return React.createElement("div", {
                  className: "Scene",
                  onTouchEnd: Curry._1(self[/* reduce */1], (function ($$event) {
                          var touches = $$event.nativeEvent.changedTouches;
                          return /* TouchEnd */Block.__(2, [
                                    Caml_array.caml_array_get(touches, 0).clientX,
                                    Caml_array.caml_array_get(touches, 0).clientY
                                  ]);
                        })),
                  onTouchStart: Curry._1(self[/* reduce */1], (function ($$event) {
                          var touches = $$event.nativeEvent.touches;
                          return /* TouchStart */Block.__(1, [
                                    Caml_array.caml_array_get(touches, 0).clientX,
                                    Caml_array.caml_array_get(touches, 0).clientY
                                  ]);
                        }))
                }, React.createElement("div", {
                      className: "Scene-content"
                    }, $$Array.of_list(List.mapi((function (i, tile) {
                                return ReasonReact.element(/* Some */[Pervasives.string_of_int(i)], /* None */0, Tile.make(i, tile, 3, +(i !== (nbOfTiles - 1 | 0)), Caml_array.caml_array_get(Images.data, self[/* state */2][/* imageIndex */4])[/* src */0], /* array */[]));
                              }), self[/* state */2][/* tiles */2]))), React.createElement("div", {
                      className: "Winning-screen",
                      style: {
                        opacity: match !== 0 ? "1" : "0",
                        transition: match$1 !== 0 ? "" : "none"
                      }
                    }, hasWon(self[/* state */2][/* tiles */2]) ? /* array */[
                        React.createElement("img", {
                              key: "solution",
                              className: "Full-image",
                              alt: "solution",
                              src: Caml_array.caml_array_get(Images.data, self[/* state */2][/* imageIndex */4])[/* src */0]
                            }),
                        React.createElement("a", {
                              key: "author",
                              className: "Origin-link",
                              href: Caml_array.caml_array_get(Images.data, self[/* state */2][/* imageIndex */4])[/* origin */1]
                            }, "By " + Caml_array.caml_array_get(Images.data, self[/* state */2][/* imageIndex */4])[/* author */2])
                      ] : null), React.createElement("div", {
                      className: "Sub-section"
                    }, React.createElement("span", {
                          className: "Tutorial",
                          style: {
                            opacity: match$2 !== 0 ? "1" : "0"
                          }
                        }, "Swipe or use keyboard arrows."), React.createElement("button", {
                          key: "new-game",
                          className: "New-game-button",
                          onClick: Curry._1(self[/* reduce */1], (function () {
                                  return /* NewGame */0;
                                }))
                        }, "New Game")), React.createElement("div", {
                      className: "About"
                    }, React.createElement("a", {
                          href: "https://github.com/GuillaumeSalles/8-squares"
                        }, "About")));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* startingX : None */0,
              /* startingY : None */0,
              /* tiles */initTiles(/* () */0),
              /* isTutorialVisible : true */1,
              /* imageIndex */Random.$$int(Images.data.length)
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      var tryToMove = function (direction) {
        var emptyTilePosition = List.nth(state[/* tiles */2], nbOfTiles - 1 | 0);
        if (hasWon(state[/* tiles */2]) || !canMove(emptyTilePosition, direction)) {
          return /* record */[
                  /* startingX : None */0,
                  /* startingY : None */0,
                  /* tiles */state[/* tiles */2],
                  /* isTutorialVisible */state[/* isTutorialVisible */3],
                  /* imageIndex */state[/* imageIndex */4]
                ];
        } else {
          return /* record */[
                  /* startingX : None */0,
                  /* startingY : None */0,
                  /* tiles */swap(state[/* tiles */2], emptyTilePosition, getTileToMove(emptyTilePosition, direction)),
                  /* isTutorialVisible : false */0,
                  /* imageIndex */state[/* imageIndex */4]
                ];
        }
      };
      if (typeof action === "number") {
        return /* Update */Block.__(0, [/* record */[
                    /* startingX */state[/* startingX */0],
                    /* startingY */state[/* startingY */1],
                    /* tiles */initTiles(/* () */0),
                    /* isTutorialVisible */state[/* isTutorialVisible */3],
                    /* imageIndex */Caml_int32.mod_(state[/* imageIndex */4] + 1 | 0, Images.data.length)
                  ]]);
      } else {
        switch (action.tag | 0) {
          case 0 : 
              return /* Update */Block.__(0, [tryToMove(keyToDirection(action[0]))]);
          case 1 : 
              return /* Update */Block.__(0, [/* record */[
                          /* startingX : Some */[action[0]],
                          /* startingY : Some */[action[1]],
                          /* tiles */state[/* tiles */2],
                          /* isTutorialVisible */state[/* isTutorialVisible */3],
                          /* imageIndex */state[/* imageIndex */4]
                        ]]);
          case 2 : 
              var match = state[/* startingX */0];
              var match$1 = state[/* startingY */1];
              if (match && match$1) {
                return /* Update */Block.__(0, [tryToMove(getSwipeDirection(match[0], match$1[0], action[0], action[1]))]);
              } else {
                return /* NoUpdate */0;
              }
          
        }
      }
    });
  return newrecord;
}

var images = Images.data;

var gridSize = 3;

exports.$$document         = $$document;
exports.images             = images;
exports.gridSize           = gridSize;
exports.nbOfTiles          = nbOfTiles;
exports.getSwipeDirection  = getSwipeDirection;
exports.$neg$neg           = $neg$neg;
exports.getRandomDirection = getRandomDirection;
exports.canMove            = canMove;
exports.getTileToMove      = getTileToMove;
exports.swap               = swap;
exports.hasWon             = hasWon;
exports.initTiles          = initTiles;
exports.keyToDirection     = keyToDirection;
exports.component          = component;
exports.make               = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/App.re
// module id = 43
// module chunks = 0